/* eslint-disable @typescript-eslint/no-unused-vars */
/* ─── Agenda-paneel: afspraken voor vandaag / 7 dagen / 4 weken ──────────── */
import { useState, useEffect, useCallback } from "react";
import { I } from "./shared";

/* ─── Agenda Panel ───────────────────────────────────────────────────────── */
// Toont afspraken van de komende 4 weken (geen koppeling met projectnummer nodig)
interface CalEvent { id: string; subject: string; start: { dateTime: string; timeZone: string }; end: { dateTime: string; timeZone: string }; location?: { displayName: string }; isAllDay: boolean; webLink: string; organizer: { emailAddress: { name: string } } }

export function AgendaPanel({graphClient,color}:{graphClient:any;color:string}){
  const[events,sEv]=useState<CalEvent[]>([]);const[ld,sLd]=useState(false);const[err,sErr]=useState("");
  const[range,setRange]=useState<"week"|"month"|"today">("week");

  const load=useCallback(async(r:"week"|"month"|"today")=>{
    sLd(true);sErr("");
    try{
      const now=new Date();
      const start=now.toISOString();
      const end=new Date(r==="today"?now.setHours(23,59,59,999):r==="week"?Date.now()+7*86400000:Date.now()+28*86400000).toISOString();
      const resp=await graphClient.api("/me/calendarView")
        .query({startDateTime:start,endDateTime:end})
        .top(50).orderby("start/dateTime")
        .select("id,subject,start,end,location,isAllDay,webLink,organizer")
        .get();
      sEv(resp.value||[]);
    }catch(e:any){sErr("Fout: "+(e.message||""))}
    sLd(false);
  },[graphClient]);

  useEffect(()=>{load(range)},[range,load]);

  // Groepeer events per dag (in lokale tijd van de browser, niet UTC)
  const byDay=events.reduce((acc,ev)=>{
    let day:string;
    if(ev.isAllDay){
      day=ev.start.dateTime.split("T")[0];
    }else{
      // Graph levert UTC terug zonder Z — voeg Z toe zodat browser correct converteert naar lokale tijd
      const localDate=new Date(ev.start.dateTime.endsWith("Z")?ev.start.dateTime:ev.start.dateTime+"Z");
      const y=localDate.getFullYear();
      const m=String(localDate.getMonth()+1).padStart(2,"0");
      const d=String(localDate.getDate()).padStart(2,"0");
      day=`${y}-${m}-${d}`;
    }
    if(!acc[day])acc[day]=[];
    acc[day].push(ev);
    return acc;
  },{} as Record<string,CalEvent[]>);

  const fmtTime=(dt:string,allDay:boolean)=>{
    if(allDay)return"Hele dag";
    // Voeg Z toe als die ontbreekt: Graph geeft UTC terug zonder Z, browser zou het anders als lokale tijd lezen
    const d=new Date(dt.endsWith("Z")?dt:dt+"Z");
    return d.toLocaleTimeString("nl-NL",{hour:"2-digit",minute:"2-digit"});
  };
  const fmtDay=(day:string)=>{
    const d=new Date(day+"T12:00:00");
    const today=new Date();today.setHours(0,0,0,0);
    const diff=Math.round((d.getTime()-today.getTime())/86400000);
    if(diff===0)return"Vandaag";
    if(diff===1)return"Morgen";
    return d.toLocaleDateString("nl-NL",{weekday:"long",day:"numeric",month:"short"});
  };

  return <div style={{display:"flex",flex:1,minHeight:0,flexDirection:"column"}}>
    {/* Bereik-selector */}
    <div style={{padding:"4px 8px",borderBottom:"1px solid #E8E8E8",display:"flex",gap:4}}>
      {(["today","week","month"] as const).map(r=>(
        <button key={r} onClick={()=>setRange(r)} style={{fontSize:10,padding:"2px 8px",borderRadius:4,border:range===r?`1px solid ${color}`:"1px solid #E0E0E0",background:range===r?color+"10":"transparent",color:range===r?color:"#9AA0A6",cursor:"pointer",fontFamily:"Segoe UI",fontWeight:500}}>
          {r==="today"?"Vandaag":r==="week"?"7 dagen":"4 weken"}
        </button>
      ))}
    </div>
    {ld&&<div style={{padding:12,color:"#9AA0A6",fontSize:11}}>Laden...</div>}
    {err&&<div style={{padding:12,color:"#D13438",fontSize:11}}>{err}</div>}
    <div style={{flex:1,overflowY:"auto"}}>
      {Object.keys(byDay).sort().map(day=>(
        <div key={day}>
          {/* Dag-header */}
          <div style={{padding:"5px 10px",background:"#F5F5F5",borderBottom:"1px solid #E8E8E8",fontSize:10,fontWeight:700,color:"#5F6368",textTransform:"capitalize",position:"sticky",top:0}}>
            {fmtDay(day)}
          </div>
          {byDay[day].map(ev=>(
            <a key={ev.id} href={ev.webLink} target="_blank" rel="noopener noreferrer"
              style={{display:"flex",gap:10,padding:"7px 10px",borderBottom:"1px solid #F5F5F5",textDecoration:"none",alignItems:"flex-start"}}
              onMouseEnter={e=>e.currentTarget.style.background="#F5F5F5"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              {/* Tijdblokje */}
              <div style={{fontSize:10,color:color,fontWeight:600,flexShrink:0,minWidth:58,paddingTop:1}}>
                {fmtTime(ev.start.dateTime,ev.isAllDay)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,color:"#1A1A1A",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ev.subject||"(geen titel)"}</div>
                {ev.location?.displayName&&<div style={{fontSize:10,color:"#9AA0A6",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>📍 {ev.location.displayName}</div>}
                <div style={{fontSize:10,color:"#9AA0A6",marginTop:1}}>{ev.organizer?.emailAddress?.name}</div>
              </div>
              <span style={{opacity:.3,flexShrink:0,paddingTop:2}}><I.Ext/></span>
            </a>
          ))}
        </div>
      ))}
      {!ld&&events.length===0&&<div style={{padding:24,textAlign:"center",color:"#9AA0A6",fontSize:12}}>Geen afspraken in deze periode.</div>}
    </div>
  </div>
}
